/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

export default {
    searchList: {
        searchTxt: [{
            name: '客户订单号',
            value: 'customerOrderNo',
            type: 'input',
            unfold: true,
            span: 4
        },
        {
            name: '发车单号',
            value: 'dispatchNo',
            type: 'input',
            unfold: true,
            span: 4
        },
        {
            name: '任务创建时间',
            value: 'createTime',
            startPlaceholder: '创建开始时间',
            endPlaceholder: '创建结束时间',
            type: 'time',
            unfold: true,
            timeNum: 3,
            span: 7
        },
        {
            name: '运输单状态',
            value: 'taskStatus',
            type: 'select',
            unfold: true,
            optionNum: 'TRANSPORT_STATUS',
            span: 3,
            options: []
        },
        {
            name: '签收类型',
            value: 'deliveredVerifyFlag',
            type: 'select',
            optionNum: 'DELIVERED_VERIFY_FLAG',
            unfold: true,
            span: 3,
            options: []
        },
        {
            name: '项目分类',
            value: 'projectClassify',
            type: 'select',
            optionNum: 'PROJECT_CLASSIFY',
            options: []
        },
        {
            name: '是否下发零担平台',
            value: 'billStatus',
            type: 'select',
            options: [
                { label: '是', value: '0' },
                { label: '否', value: '1' }
            ]
        }],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        selectBtn: true,
        fixedSeletionColumn: true,
        height: 400,
        leftWidth: 70,
        columns: [{
            label: '运输单号',
            prop: 'taskNo',
            width: '180px',
            sort: true
        },
        {
            label: '客户订单号',
            prop: 'customerOrderNo',
            width: '200px',
            sort: true
        },
        {
            label: '发车单号',
            prop: 'dispatchNo',
            width: '200px'
        },
        {
            label: '源发车单号',
            prop: 'sourceDispatch',
            sort: true,
            width: '200px'
        },
        {
            label: '订单类型',
            prop: 'orderTypeName',
            width: '120px',
            sort: true
        },
        {
            label: '任务类型',
            prop: 'taskTypeName',
            width: '120px',
            sort: true
        },
        {
            label: '运输单状态',
            prop: 'taskStatusName',
            width: '100px',
            sort: true
        },
        {
            label: '波次号',
            prop: 'waveId',
            width: '120px',
            sort: true
        },
        {
            label: '签收类型',
            prop: 'deliveredVerifyFlagName',
            width: '120px',
            sort: true
        },
        {
            label: '来源系统',
            prop: 'sourceSystemName',
            width: '120px',
            sort: true
        },
        {
            label: '收货详细地址',
            prop: 'receiverDetailAddr',
            type: 'desensitized',
            width: '300px',
            sort: true
        },
        {
            label: '收货人',
            prop: 'receiverName',
            type: 'desensitized',
            width: '148px',
            sort: true
        },
        {
            label: '收货人固定电话',
            prop: 'receiverTel',
            type: 'desensitized',
            width: '148px',
            sort: true
        },
        {
            label: '收货人手机号码',
            prop: 'receiverMobile',
            type: 'desensitized',
            width: '148px',
            sort: true
        },
        {
            label: '实扫数量',
            prop: 'rfActLoadQty',
            width: '150px',
            sort: true
        },
        {
            label: '实发数量',
            prop: 'qtyItemLoaded',
            width: '100px',
            sort: true
        },
        {
            label: '计划数量',
            prop: 'totalQty',
            width: '120px',
            sort: true
        },
        {
            label: '计划体积',
            prop: 'totalVolume',
            width: '120px',
            sort: true
        },
        {
            label: '计划重量',
            prop: 'totalGrossWeight',
            width: '120px',
            sort: true
        },
        // 数量/实发数量
        {
            label: '数量',
            prop: 'qtyItemLoadedCopy',
            width: '100px',
            sort: true
        },
        // 总数量/计划数量
        {
            label: '总数量',
            prop: 'totalQtyCopy',
            width: '120px',
            sort: true
        },
        // 体积(m³)/计划体积
        {
            label: '体积(m³)',
            prop: 'totalVolumeCopy',
            width: '120px',
            sort: true
        },
        // 重量（kg）/计划重量
        {
            label: '重量（kg）',
            prop: 'totalGrossWeightCopy',
            width: '120px',
            sort: true
        },
        {
            label: '合同号',
            prop: 'contractNo',
            width: '140px',
            sort: true
        },
        {
            label: '设备号',
            prop: 'dispatchDeviceNo',
            width: '140px',
            sort: true
        },
        {
            label: '设备绑定时间',
            prop: 'deviceNoBoundTime',
            width: '160px',
            sort: true
        },
        {
            label: '开票单位',
            prop: 'invoiceUnitName',
            width: '160px',
            sort: true
        },
        {
            label: '车牌号',
            prop: 'vehicleCard',
            width: '160px',
            sort: true
        },
        {
            label: '下发承运商时间',
            prop: 'carrierVisibleTime',
            width: '200px',
            sort: true
        },
        {
            label: '网点编码',
            prop: 'networkCode',
            width: '110px',
            sort: true
        },
        {
            label: '网点名称',
            prop: 'networkName',
            width: '140px',
            sort: true
        },
        {
            label: '服务平台',
            prop: 'siteName',
            width: '110px',
            sort: true
        },
        {
            label: '任务创建时间',
            prop: 'createTime',
            width: '148px',
            sort: true
        },
        {
            label: '订单创建时间',
            prop: 'orderTime',
            width: '148px',
            sort: true
        },
        {
            label: '客户',
            prop: 'customerName',
            width: '148px',
            sort: true
        },
        {
            label: '客户编码',
            prop: 'customerCode',
            width: '148px',
            sort: true
        },
        {
            label: '业务模式',
            prop: 'businessMode',
            width: '80px',
            sort: true
        },
        {
            label: '配送方式',
            prop: 'deliveryTypeName',
            width: '80px',
            sort: true
        },
        {
            'label': '采购渠道',
            'sort': true,
            'prop': 'procurementChannelName',
            'width': 110
        },
        {
            label: '是否下发',
            prop: 'carrierVisibleFlagName',
            width: '80px',
            sort: true
        },
        {
            label: '是否分拨订单',
            prop: 'distributionFlagName',
            width: '80px',
            sort: true
        },
        {
            label: '是否继续分拨',
            prop: 'distributionContinueFlagName',
            width: '80px',
            sort: true
        },
        {
            label: '是否代收',
            prop: 'collectionFlagName',
            sort: true,
            width: 110
        },
        {
            label: '运费类型',
            prop: 'deliverypayTypeName',
            sort: true,
            width: 110
        },
        {
            label: '目的地省',
            prop: 'receiverProvinceName',
            width: '100px',
            sort: true
        },
        {
            label: '目的地市',
            prop: 'receiverCityName',
            width: '148px',
            sort: true
        },
        {
            label: '目的地区',
            prop: 'receiverDistrictName',
            width: '148px',
            sort: true
        },
        {
            label: '目的地乡镇',
            prop: 'receiverTownName',
            width: '148px',
            sort: true
        },
        {
            label: '仓库',
            prop: 'whName',
            width: '148px',
            sort: true
        },
        {
            label: '销售员名称',
            prop: 'salesmanName',
            width: '150px'
        },
        {
            label: '事业部集拼单号',
            prop: 'assembleNo',
            width: 200
        },
        {
            label: '营销中心',
            prop: 'salesCenterName',
            width: 200
        },
        {
            label: '发货地省',
            prop: 'senderProvinceName',
            width: '148px',
            sort: true
        },
        {
            label: '发货地市',
            prop: 'senderCityName',
            width: '148px',
            sort: true
        },
        {
            label: '发货地区县',
            prop: 'senderDistrictName',
            width: '148px',
            sort: true
        },
        {
            label: '发货地乡镇',
            prop: 'senderTownName',
            width: '148px',
            sort: true
        },
        {
            label: '线路名称',
            prop: 'lineName',
            width: '160px',
            sort: true
        },
        {
            label: '线路名称(旧)',
            prop: 'lineNameV1',
            width: '160px',
            sort: true
        },
        {
            label: '推荐车型',
            prop: 'planEquipmentName',
            width: '160px',
            sort: true
        },
        {
            label: '商品名称',
            prop: 'itemName',
            width: '160px',
            sort: true
        },
        {
            label: '统一分段标识',
            prop: 'tyLineMark',
            width: '160px',
            sort: true
        },
        {
            label: '原承运商',
            prop: 'planCarrierName',
            width: '160px',
            sort: true
        },
        {
            label: '承运商',
            prop: 'carrierName',
            width: '160px',
            sort: true
        },
        {
            label: '承运商编码',
            prop: 'carrierCode',
            width: '160px',
            sort: true
        },
        {
            label: '是否供应商转快递',
            prop: 'supplierKdFlag',
            type: 'select',
            optionNum: 'SUPPLIER_KD_FLAG',
            options: [],
            width: '160px',
            sort: true
        },
        {
            label: '订单服务类型',
            prop: 'serviceType',
            type: 'select',
            optionNum: 'ORDER_SERVICE_TYPE',
            options: [],
            width: '160px',
            sort: true
        },
        {
            label: '业务场景',
            prop: 'businessCategoryName',
            width: '120px',
            sort: true
        },
        {
            'label': '终端省',
            'prop': 'finalProvinceName',
            'sort': true,
            'width': '120px'
        },
        {
            'label': '终端市',
            'prop': 'finalCityName',
            'sort': true,
            'width': '120px'
        },
        {
            'label': '终端区县',
            'prop': 'finalDistrictName',
            'sort': true,
            'width': '120px'
        },
        {
            'label': '终端乡镇',
            'prop': 'finalTownName',
            'sort': true,
            'width': '120px'
        },
        {
            'label': '终端详细地址',
            'prop': 'finalDetailAddr',
            'type': 'desensitized',
            'sort': true,
            'width': '120px'
        },
        {
            label: '工号',
            prop: 'workOrderNo',
            sort: true,
            width: 160
        },
        {
            label: '要求提货开始时间',
            prop: 'expectPickStartTime',
            sort: true,
            width: 160
        },
        {
            label: '要求提货结束时间',
            prop: 'expectPickEndTime',
            sort: true,
            width: 160
        },
        {
            'label': '包件数',
            'prop': 'totalPkgQty',
            'sort': true,
            'width': 100
        },
        {
            'label': '项目分类',
            'prop': 'projectClassifyName',
            'sort': true,
            'width': 110
        },
        {
            'label': '下发零担平台',
            'prop': 'billStatusName',
            'sort': true,
            'width': 110
        },
        {
            'label': '对接平台',
            'prop': 'externalType',
            'sort': true,
            'width': 110
        },
        {
            'label': '预约时间',
            'prop': 'appointmentTime',
            'sort': true,
            'width': 160
        },
        {
            'label': '预约类型',
            'prop': 'snAppointmentTypeName',
            'sort': true,
            'width': 160
        },
        {
            'label': '发运类型',
            'prop': 'shippingTypeName',
            'sort': true,
            'width': 120
        },
        {
            'label': '服务产品编码',
            'prop': 'productCode',
            'sort': true,
            'width': 120
        },
        {
            'label': '服务产品名称',
            'prop': 'productName',
            'sort': true,
            'width': 120
        },
        {
            label: '收货单位',
            prop: 'upperReceiverName',
            type: 'desensitized',
            width: '160px',
            sort: true
        },
        {
            label: '场景标识',
            prop: 'loanScenarioCode',
            type: 'select',
            optionNum: 'CUSTOMER_SCENCE',
            options: [],
            sort: true,
            width: 110
        },
        {
            label: '京东VC单号',
            prop: 'jdVcNo',
            sort: true,
            width: 160
        },
        {
            label: '预约单号',
            prop: 'snAppointmentNo',
            sort: true,
            width: 160
        },
        {
            label: '是否基地',
            prop: 'orderDistinctionFlagName',
            width: '160px',
            sort: true
        },
        {
            label: '到车人工操作原因',
            prop: 'arriveOperateReason',
            width: '160px',
            sort: true
        },
        {
            label: '抵达人工操作原因',
            prop: 'arrivalOperateReason',
            width: '160px',
            sort: true
        },
        {
            label: '计划单号',
            prop: 'planOrderNo',
            width: '160px',
            sort: true
        },
        // {
        //     label: '是否已提货',
        //     prop: 'pickUpStatusName',
        //     width: '160px',
        //     sort: true
        // },
        {
            label: '包裹数',
            prop: 'sumPackages',
            width: '160px',
            sort: true
            },
        {
            label: '是否2C批量直配',
            prop: 'b2cZpFlagName',
            sort: true,
            width: 150
        },
        // add 2025-3-28
        {
            label: '分公司',
            prop: 'companyName',
            width: '120px',
            sort: true
        },
        {
            label: '目的地详细地址',
            prop: 'finalDetailAddr',
            type: 'desensitized',
            sort: true,
            width: 160
        },
        {
            label: '始发仓',
            prop: 'orderWhName',
            width: '80px',
            sort: true
        },
        {
            label: '仓库分组',
            prop: 'warehouseGroup',
            width: '148px',
            sort: true
        },
        {
            label: '分拨仓库',
            prop: 'distributionWhName',
            width: '120px'
        },
        {
            label: '仓网融合平台',
            prop: 'fuseSiteName',
            width: '100px',
            sort: true
        },
        {
            label: '库区名称',
            prop: 'zoneName',
            width: '80px',
            sort: true
        },
        {
            label: '下发人',
            prop: 'issueCarrierMip',
            width: '150px'
        },
        {
            label: '供方预约',
            prop: 'supplierReserveFlag',
            type: 'select',
            optionNum: '',
            options: [
                { value: 'Y', label: '是' },
                { value: 'N', label: '否' }
            ],
            width: '110px',
            sort: true
        },
        {
            label: '备注',
            prop: 'remark',
            width: '200px'
        },
        {
            label: '实际抵达时间',
            prop: 'arrivalTime',
            width: '200px',
            sort: true
        },
        {
            label: '要求抵达时间',
            prop: 'requireArriveTime',
            width: '200px',
            sort: true
        },
        {
            label: '实际签收时间',
            prop: 'signTime',
            width: '200px',
            sort: true
        },
        {
            label: '实际发车时间',
            prop: 'actDepartTime',
            width: '200px',
            sort: true
        },
        {
            label: '目的地收货人',
            prop: 'finalName',
            type: 'desensitized',
            sort: true,
            width: 160
        },
        {
            label: '上游集拼单号',
            prop: 'consolidationOrderNo',
            sort: true,
            width: 180
        },
        {
            label: '专业公司',
            prop: 'professionalCompany',
            type: 'select',
            optionNum: 'SYS_PROFESSIONAL_COMPANY',
            options: [],
            sort: true,
            width: 130
        },
        {
            label: '要求到车时间',
            prop: 'requireCarArriveTime',
            width: '200px',
            sort: true
        },
        {
            label: '要求发货时间',
            prop: 'requireOutTime',
            width: '200px',
            sort: true
        },
        {
            label: '要求发车时间',
            prop: 'requireDepartTime',
            width: '200px',
            sort: true
        },
        {
            label: '要求签收时间',
            prop: 'requestSignDate',
            width: '200px',
            sort: true
        },
        {
            label: '线路里程',
            prop: 'mileage',
            width: '148px',
            sort: true
        },
        {
            label: '是否扫码',
            prop: 'scanFlag',
            type: 'select',
            optionNum: 'SCAN_FLAG',
            options: [],
            sort: true,
            width: 120
        },
        {
            label: '是否提供装卸服务',
            prop: 'handlingStatusName',
            width: '160px',
            sort: true
        },
        {
            label: '装卸供应商',
            prop: 'handlingCarrierName',
            width: '160px',
            sort: true
        },
        {
            label: '设备类型',
            prop: 'deviceTypeName',
            sort: true,
            width: 160
        },
        {
            label: 'VP客户标识',
            prop: 'vipFlagName',
            sort: true,
            width: 160
        },
        {
            label: '平台单号',
            prop: 'platformOrderNo',
            width: '160px',
            sort: true
        },
        {
            label: '齐套号',
            prop: 'qtOrderNo',
            sort: true,
            width: 160
        },
        {
            label: '线路类别',
            prop: 'orderLineType',
            type: 'select',
            optionNum: 'ORDER_LINE_TYPE',
            options: [],
            width: '160px',
            sort: true
        },
        {
            label: '仓货标识',
            prop: 'warehouseIdentification',
            type: 'select',
            optionNum: 'WAREHOUSE_IDENTIFICATION',
            options: [],
            width: '160px',
            sort: true
        },
        {
            label: '出库时间',
            prop: 'loadDate',
            sort: true,
            width: 160
        },
        {
            label: '运输类型',
            prop: 'transportType',
            type: 'select',
            optionNum: 'TRANSPORT_TYPE',
            options: [],
            sort: true,
            width: 160
        },
        {
            label: '高端服务',
            prop: 'highEndServiceType',
            type: 'select',
            optionNum: 'TMS_EMERGENCE_FLAG',
            options: [],
            sort: true,
            width: 140
            },
        {
			label: "计费业务类型",
			prop: "businessType",
			type: "select",
			optionNum: "BUSINESS_TYPE",
            options: [],
			sort: true,
			width: 140
		},
        {
            label: '事业部',
            prop: 'entityIdName',
            sort: true,
            width: 160
        },
        {
            label: '订单标签',
            prop: 'orderLabel',
            sort: true,
            width: 160
        },
        {
            'label': '套送号',
            'prop': 'completeSetNo',
            'sort': true,
            'width': 140
        }
        ],
        action: [
            {
                type: 'text',
                label: '修改',
                size: 'mini',
                event: 'changeAddress',
                ifHas: '04030001'
            }],
        leftOperation: true
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    },
    searchTotalTitle: [
        {
            name: '运输单号',
            value: 'taskNo',
            type: 'input'
        },
        {
            name: '波次号',
            value: 'waveId',
            type: 'input',
        },
        {
            name: '源发车单号',
            value: 'sourceDispatch',
            type: 'input'
        },
        {
            name: '订单类型',
            value: 'orderTypeList',
            optionNum: 'ORDER_TYPE',
            filterable: true,
            multiple: true,
            type: 'select',
            options: []
        },
        {
            name: '任务类型',
            value: 'taskType',
            type: 'select',
            optionNum: 'TASK_TYPE',
            options: []
        },
        {
            name: '配送方式',
            value: 'deliveryType',
            optionNum: 'DELIVERY_TYPE',
            type: 'select',
            options: []
        },
        {
            'name': '采购渠道',
            'value': 'procurementChannel',
            'optionNum': 'OTP_TMS_PROCUREMENT_CHANNEL',
            'options': [],
            'type': 'select'
        },
        {
            name: '是否分拨订单',
            value: 'distributionFlag',
            type: 'select',
            options: [
                { label: '是', value: 'Y' },
                { label: '否', value: 'N' }
            ]
        },
        {
            name: '是否继续分拨',
            value: 'distributionContinueFlag',
            type: 'select',
            options: [
                { label: '是', value: 'Y' },
                { label: '否', value: 'N' }
            ]
        },
        {
            name: '业务大类',
            value: 'businessCategory',
            optionNum: 'BUSINESS_CATEGORY',
            type: 'select',
            options: []
        },
        {
            name: '服务平台',
            advanceLabel: '服务平台',
            value: 'siteName',
            multiple: true,
            border: true,
            dialogWidth: '800px',
            multipleTableColumn: {
                prop: 'escoCompanyNameCn', 'value': '服务平台名称'
            },
            advanceConfig: [
                { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                { prop: 'escoCompanyNo', value: '服务平台编码' }
            ],
            tableConfig: [
                { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                { prop: 'escoCompanyNo', value: '服务平台编码' }
            ],
            method: 'post',
            prefix: '/api-tms',
            advanceUrl: '/user/auth/data/site/query',
            type: 'advance',
            cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName']
        },
        {
            name: '网点名称',
            value: 'networkName',
            type: 'input'
        },
        {
            name: '客户',
            value: 'cpName',
            type: 'advance',
            unfold: true,
            advanceConfig: [
                { 'prop': 'ebcuNameCn', 'value': '客户名称' },
                { 'prop': 'pmCode', 'value': '客户编码' }
            ],
            tableConfig: [
                { 'prop': 'pmCode', 'value': '客户编码' },
                { 'prop': 'ebcuNameCn', 'value': '客户名称' }
            ],
            advanceUrl: '/ebCustomer/searchByEbCustomer',
            cbParams: ['pmCode#customerCode', 'ebcuNameCn#cpName'],
            advanceCode: 'advanceCode'
        },
        {
            name: '目的地省',
            value: 'receiverProvinceName',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'ebplNameCn', 'value': '目的地省名称' },
                { 'prop': 'ebplCode', 'value': '目的地省编码' }
            ],
            tableConfig: [
                { 'prop': 'ebplNameCn', 'value': '目的地省名称' },
                { 'prop': 'ebplCode', 'value': '目的地省编码' }
            ],
            cbParams: [
                'ebplCode#receiverProvinceCode', 'ebplNameCn#receiverProvinceName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_PROVINCE&ebplParentPmCode=100000',
            advanceCode: 'receiverProvinceCode'
        },
        {
            name: '目的地市',
            value: 'receiverCityName',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'ebplNameCn', 'value': '目的地市名称' },
                { 'prop': 'ebplCode', 'value': '目的地市编码' }
            ],
            tableConfig: [
                { 'prop': 'ebplNameCn', 'value': '目的地省名称' },
                { 'prop': 'ebplCode', 'value': '目的地市编码' }
            ],
            cbParams: [
                'ebplCode#receiverCityCode', 'ebplNameCn#receiverCityName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_CITY',
            advanceCode: 'receiverCityCode'
        },
        {
            name: '目的地区',
            value: 'receiverDistrictName',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'ebplNameCn', 'value': '目的地区名称' },
                { 'prop': 'ebplCode', 'value': '目的地区编码' }
            ],
            tableConfig: [
                { 'prop': 'ebplNameCn', 'value': '目的地区名称' },
                { 'prop': 'ebplCode', 'value': '目的地区编码' }
            ],
            cbParams: [
                'ebplCode#receiverDistrictCode', 'ebplNameCn#receiverDistrictName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_DISTRICT',
            advanceCode: 'receiverDistrictCode'
        },
        {
            name: '目的地乡镇',
            value: 'receiverTownName',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'ebplNameCn', 'value': '目的地乡镇名称' },
                { 'prop': 'ebplCode', 'value': '目的地乡镇编码' }
            ],
            tableConfig: [
                { 'prop': 'ebplNameCn', 'value': '目的地乡镇名称' },
                { 'prop': 'ebplCode', 'value': '目的地乡镇编码' }
            ],
            cbParams: [
                'ebplCode#receiverTownCode', 'ebplNameCn#receiverTownName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_STREET',
            advanceCode: 'receiverTownCode'
        },
        {
            name: '发货地省',
            value: 'senderProvinceName',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'ebplNameCn', 'value': '发货地省名称' },
                { 'prop': 'ebplCode', 'value': '发货省编码' }
            ],
            tableConfig: [
                { 'prop': 'ebplNameCn', 'value': '发货地省名称' },
                { 'prop': 'ebplCode', 'value': '发货地省编码' }
            ],
            cbParams: [
                'ebplCode#senderProvinceCode', 'ebplNameCn#senderProvinceName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_PROVINCE&ebplParentPmCode=100000',
            advanceCode: 'senderProvinceCode'
        },
        {
            name: '发货地市',
            value: 'senderCityName',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'ebplNameCn', 'value': '发货地市名称' },
                { 'prop': 'ebplCode', 'value': '发货地市编码' }
            ],
            tableConfig: [
                { 'prop': 'ebplNameCn', 'value': '发货地市名称' },
                { 'prop': 'ebplCode', 'value': '发货地市编码' }
            ],
            cbParams: [
                'ebplCode#senderCityCode', 'ebplNameCn#senderCityName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_CITY',
            advanceCode: 'senderCityCode'
        },
        {
            name: '发货地区',
            value: 'senderDistrictName',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'ebplNameCn', 'value': '发货地区名称' },
                { 'prop': 'ebplCode', 'value': '发货地区编码' }
            ],
            tableConfig: [
                { 'prop': 'ebplNameCn', 'value': '发货地区名称' },
                { 'prop': 'ebplCode', 'value': '发货地区编码' }
            ],
            cbParams: [
                'ebplCode#senderDistrictCode', 'ebplNameCn#senderDistrictName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_DISTRICT',
            advanceCode: 'senderDistrictCode'
        },
        {
            name: '发货地乡镇',
            value: 'senderTownName',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'ebplNameCn', 'value': '发货地乡镇名称' },
                { 'prop': 'ebplCode', 'value': '发货地乡镇编码' }
            ],
            tableConfig: [
                { 'prop': 'ebplNameCn', 'value': '发货地乡镇名称' },
                { 'prop': 'ebplCode', 'value': '发货地乡镇编码' }
            ],
            cbParams: [
                'ebplCode#senderTownCode', 'ebplNameCn#senderTownName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_STREET',
            advanceCode: 'senderTownCode'
        },
        {
            name: '网点编码',
            value: 'networkCode',
            type: 'input'
        },
        {
            name: '承运商',
            value: 'carrierName',
            type: 'advance',
            advanceConfig: [
                { prop: 'supplierNameCn', value: '承运商名称' },
                { prop: 'supplierCode', value: '承运商编码' }
            ],
            tableConfig: [
                { prop: 'supplierNameCn', value: '承运商名称' },
                { prop: 'supplierCode', value: '承运商编码' },
                { prop: 'transNameListStr', value: '采购渠道' }
            ],
            advanceNotSearch: true,
            queryConditionRequired: true,
            method: 'post',
            prefix: '/api-tms',
            advanceUrl: '/srm/supplier/search',
            cbParams: ['supplierNameCn#carrierName', 'supplierCode#carrierCode']
        },
        {
            name: '原承运商',
            value: 'planCarrierName',
            type: 'advance',
            advanceConfig: [
                { prop: 'supplierNameCn', value: '承运商名称' },
                { prop: 'supplierCode', value: '承运商编码' }
            ],
            tableConfig: [
                { prop: 'supplierNameCn', value: '承运商名称' },
                { prop: 'supplierCode', value: '承运商编码' },
                { prop: 'transNameListStr', value: '采购渠道' }
            ],
            advanceNotSearch: true,
            queryConditionRequired: true,
            method: 'post',
            prefix: '/api-tms',
            advanceUrl: '/srm/supplier/search',
            cbParams: ['supplierNameCn#planCarrierName', 'supplierCode#planCarrierCode']
        },
        {
            name: '线路名称',
            value: 'lineName',
            type: 'advance',
            advanceConfig: [
                { prop: 'lineMergeName', value: '线路名称' },
                { prop: 'lineMergeId', value: '线路编码' }
            ],
            tableConfig: [
                { prop: 'lineMergeName', value: '线路名称' },
                { prop: 'lineMergeId', value: '线路编码' }
            ],
            method: 'post',
            paramType: true,
            prefix: '/api-opms/',
            advanceUrl: `opms/searchMergeLine`,
            cbParams: ['lineMergeName#lineName', 'lineMergeId#lineCode']
        },
        {
            name: '线路名称(旧)',
            value: 'lineNameV1',
            type: 'advance',
            advanceConfig: [
                { prop: 'all', value: '全部' },
                { prop: 'lineCode', value: '线路编码' },
                { prop: 'lineName', value: '线路名称' }
            ],
            prefix: '/api-dc',
            advanceUrl: `/line/page`,
            cbParams: ['lineCode#lineCodeV1', 'lineName#lineNameV1'],
            tableConfig: [
                { prop: 'lineCode', value: '线路编码' },
                { prop: 'lineName', value: '线路名称' }
            ]
        },
        {
            name: '来源系统',
            value: 'sourceSystem',
            optionNum: 'SOURCE_SYSTEM',
            type: 'select',
            options: []
        },
        {
            name: '是否供应商转快递',
            value: 'supplierKdFlag',
            type: 'select',
            optionNum: 'SUPPLIER_KD_FLAG',
            options: []
        },
        {
            name: '场景标识',
            value: 'loanScenarioCodeList',
            type: 'select',
            multiple: true,
            filterable: true,
            maxSelect: 10,
            optionNum: 'CUSTOMER_SCENCE',
            options: []
        },
        {
            name: '发运类型',
            value: 'shippingType',
            optionNum: 'TMS_SHIPPING_TYPE',
            type: 'select',
            options: []
        },
        {
            name: '服务产品编码',
            value: 'productCode',
            type: 'input'
        },
        {
            name: '事业部集拼号',
            value: 'assembleNo',
            type: 'input'
        },
        {
            name: '服务产品名称',
            value: 'productName',
            type: 'input'
        },
        {
            name: '收货单位',
            value: 'upperReceiverName',
            type: 'input'
        },
        {
            name: '是否下发承运商',
            value: 'carrierVisibleFlag',
            type: 'select',
            options: [
                { value: 'Y', label: '是' },
                { value: 'N', label: '否' }
            ]
        },
        {
            name: '车牌号',
            value: 'vehicleCard',
            type: 'input'
        },
        {
            name: '是否2C批量直配',
            value: 'b2cZpFlag',
            type: 'select',
            optionNum: '',
            options: [
                { 'value': '1', 'label': '是' },
                { 'value': '0', 'label': '否' }
            ]
        },
        {
            'name': '套送号',
            'value': 'completeSetNo',
            'type': 'input'
        },

        {
            name: '要求发车时间',
            value: 'requireDepartTime',
            startPlaceholder: '开始时间',
            endPlaceholder: '结束时间',
            type: 'time'
        },
        {
            name: '要求到车时间',
            value: 'requireCarArriveTime',
            startPlaceholder: '开始时间',
            endPlaceholder: '结束时间',
            type: 'time'
        },
        {
            name: '要求抵达时间',
            value: 'requireArriveTime',
            startPlaceholder: '开始时间',
            endPlaceholder: '结束时间',
            type: 'time'
        },
        {
            name: '要求签收时间',
            value: 'requestSignDate',
            startPlaceholder: '开始时间',
            endPlaceholder: '结束时间',
            type: 'time'
        }
    ]
};
